exports.list = {
    path: '/mata_uang',
    name: 'mata_uang', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/mata_uang/List.vue"),
}
exports.show = {
    path: '/mata_uang/show/:kode',
    name: 'mata_uang_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/mata_uang/Show.vue"),
}